@if (trixelUrl()) {
  <rma-trixel [trixelImgUrl]="trixelUrl()" />
}

<img
  [ngSrc]="avatar() || placeholderImage()"
  [alt]="name() ?? 'placeholder'"
  [style.background-color]="backgroundColour()"
  [priority]="lazyLoad() ? false : true"
  [loaderParams]="{ transformations: transformations() }"
  class="h-full w-full object-cover"
  disableOptimizedSrcset="true"
  fill
  rmaBrokenImage />
